import { Pages } from "./types";

export const enum AnalyticsPageLaunchpad {
  Launchpad = "Launchpad",
}

export const pagesLaunchpad: Pages<AnalyticsPageLaunchpad> = {
  [AnalyticsPageLaunchpad.Launchpad]: ["Launchpad"],
};
